import { gql } from '@apollo/client';

export const UPDATE_PAGECONTENT_MUTATION = gql`
  mutation updateNdPageContent($input: NdUpdPageContentInput!) {
    updateNdPageContent(input: $input) {
      id
      success
    }
  }
`;